import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-edit-icon-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './edit-icon-button.html',
  styleUrl: './edit-icon-button.scss'
})
export class EditIconButton {
  @Input() disabled: boolean = false;
  @Input() tooltip: string = 'Szerkesztés';
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' = 'above';
  @Input() color: 'primary' | 'accent' | 'warn' | undefined = 'accent';
  @Output() clicked = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
